<template>
  <div>
    <InfoAlert :inline="true" type="auctions" />
    <TopCategoryMenu />
    <CarouselBanner type="auctions" />
    <div name="grid" class="flex justify-center mx-auto">
      <CategoryDropdownSidebar :type="CATEGORY_TYPE.ESHOP" />
      <main class="flex-1 sm:flex-none">
        <Feed :product-type="PRODUCT_TYPE.AUCTION" />
      </main>
    </div>
    <CartCounterButton />
  </div>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import { CATEGORY_TYPE, PRODUCT_TYPE } from "@utils/constants";
import { sitePages } from "@settings/site-pages.settings";
import CarouselBanner from "@components/common/carousel-banner";
import CategoryDropdownSidebar from "@components/category/category-dropdown-sidebar";
import Feed from "@components/product/feed";
import CartCounterButton from "@components/cart/cart-counter-button";
import TopCategoryMenu from "@components/category/top-category-menu";

definePageMeta({
  layout: 'shop-layout'
});

defineI18nRoute({
  paths: {
    cs: '/aukce',
    en: '/auctions',
    sk: '/aukcie',
    pl: '/aukcje',
    de: '/auktionen'
  }
});

const { t } = useI18n();
const config = useRuntimeConfig();
const canonical = config.public.appBaseUrl + translatePath(ROUTES.CODE.AUCTIONS);
const { title: seoTitle, ogUrl } = useFilterSeoTitle(() => t('nav-menu-auctions'));

useHead({ link: [ { rel: 'canonical', href: canonical } ] });
useSeoMeta({
  title: () => seoTitle.value,
  ogTitle: () => seoTitle.value,
  description: `${t(sitePages[config.public.layoutDesign].auctions[0].heading)} - ${t(sitePages[config.public.layoutDesign].auctions[0].subheading).replace('<br>', ' ')}`,
  ogDescription: `${t(sitePages[config.public.layoutDesign].auctions[0].heading)} - ${t(sitePages[config.public.layoutDesign].auctions[0].subheading).replace('<br>', ' ')}`,
  ogImage: `${config.public.appBaseUrl}${sitePages[config.public.layoutDesign].auctions[0].image}`,
  ogType: `${sitePages[config.public.layoutDesign].type}`,
  ogUrl: () => ogUrl.value
});

</script>
